import React, { useState, useEffect } from "react";
import axios from "axios";
import { OpenVidu } from "openvidu-browser";
import Loader from "react-loader";

import styles from "./Stream.module.css"
import { BACKEND_URL_PREFIX } from "../../utils/const";


import { buildDefaultHeaders } from '../../actions/helper'

export function Stream() {


  const URL = process.env.REACT_APP_CAMERAS_URL
  const SECRET = process.env.REACT_APP_CAMERAS_SECRET

  const [sessionId, setSessionId] = useState(null);
  const [cameras, setCameras] = useState(null);
  const [loading, setLoading] = useState(false)
  
  const [data] = useState({
    type: "IPCAM",
    data: null,
    record: true,
    rtspUri: null,
    adaptativeBitrate: true,
    onlyPlayWithSubscribers: true,
    networkCache: 2000,
  })

  const [subscriber] = useState({
    type: "WEBRTC",
    data: "My Server Data",
    record: true,
    role: "SUBSCRIBER",
    kurentoOptions: {
      videoMaxRecvBandwidth: 1000,
      videoMinRecvBandwidth: 300,
      videoMaxSendBandwidth: 1000,
      videoMinSendBandwidth: 300,
      allowedFilters: ["GStreamerFilter", "ZBarFilter"],
    },
  });

  useEffect(() => {
    createSession().then((id) => setSessionId(id));
    getCamerasList()
  }, []);

  useEffect(() => {
    if (!cameras || !sessionId) return;
    cameras.forEach((item,i) => createConnection(sessionId, {...data, rtspUri:item.stream, data: item.room}))    
    joinSession(sessionId).then((token) => subscribe(token));
  }, [cameras, sessionId]);

  const getCamerasList = async () => {
    const { data } = await axios.get(`${BACKEND_URL_PREFIX}/camera`, {...buildDefaultHeaders()})
    setCameras(data.cameras)
  }

  const createSession = () => {
    return new Promise((resolve, reject) => {
      setLoading(true)
      axios
        .post(
          URL + "/openvidu/api/sessions",
          {},
          {
            headers: {
              Authorization: "Basic " + btoa("OPENVIDUAPP:" + SECRET),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //TODO проверить при норм запросе с данными
          if (response.data.length === 0) {
            var h1elem = document.createElement("h1");
           h1elem.appendChild(document.createTextNode("Нет настроенных видеокамер"))
           h1elem.classList.add(styles.noCamerasTitle);
           document.getElementById("cameras").appendChild(h1elem); 
          } else  resolve(response.data.id) 
        })
        .catch(async (response) => { 
          var error = Object.assign({}, response);
          var h1elem = document.createElement("h1");
          h1elem.appendChild(document.createTextNode("Видеокамеры отсутствуют"))
          h1elem.classList.add(styles.noCamerasTitle);
          document.getElementById("cameras").appendChild(h1elem);
          // if (error.response?.status === 409) {
          //   resolve(sessionId);
          // } else {
          //   console.warn(
          //     "No connection to OpenVidu Server. This may be a certificate error at " +
          //       URL
          //   );
          //   if (
          //     window.confirm(
          //       'No connection to OpenVidu Server. This may be a certificate error at "' +
          //         URL +
          //         '"\n\nClick OK to navigate and accept it. ' +
          //         'If no certificate warning is shown, then check that your OpenVidu Server is up and running at "' +
          //         URL +
          //         '"'
          //     )
          //   ) {
          //     window.location.assign(URL + "/accept-certificate");
          //   }
          // }
        })
        .finally(() => setLoading(false)
        )
    });
  };

  const createConnection = (sessionId, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          URL + "/openvidu/api/sessions/" + sessionId + "/connection",
          data,
          {
            headers: {
              Authorization: "Basic " + btoa("OPENVIDUAPP:" + SECRET),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          resolve(response.data.token);
        })
        .catch((error) => reject(error));
    });
  };

  const joinSession = () => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          URL + "/openvidu/api/sessions/" + sessionId + "/connection",
          subscriber,
          {
            headers: {
              Authorization: "Basic " + btoa("OPENVIDUAPP:" + SECRET),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          resolve(response.data.token);
        })
        .catch((error) => reject(error));
    });
  };

  const subscribe = (token) => {
    const OV = new OpenVidu();
    
    const session = OV.initSession();

    session.on("streamCreated", (event) => {
      var videoDiv = document.createElement("div");
      var stream = event.stream;
      videoDiv.classList.add(styles.video);
      videoDiv.id = stream.streamId;
      document.getElementById("cameras").appendChild(videoDiv);
      var subscriber = session.subscribe(stream, videoDiv);

      subscriber.on("videoElementCreated", (ev) => {
        var cameraName = document.createElement("div");
        cameraName.innerText = stream.connection.data;
        cameraName.classList.add(styles.cameraName);
        ev.element.parentNode.insertBefore(cameraName, ev.element);
        var loader = document.createElement("div");
        loader.classList.add("loader");
        ev.element.parentNode.insertBefore(loader, ev.element.nextSibling);
      });

      subscriber.on("streamPlaying", (ev) => {
        var cameraVideoElement = subscriber.videos[0].video;
        cameraVideoElement.parentNode.removeChild(
          cameraVideoElement.nextSibling
        );
        autoplayMutedVideoIfBlocked(cameraVideoElement);
      });

      subscriber.on("videoElementDestroyed", (ev) => {
        var videoContainer = document.getElementById(stream.streamId);
        videoContainer.parentNode.removeChild(videoContainer);
      });
    });

    session.on("exception", (exception) => {
      console.warn(exception);
    });

    session.connect(token).catch((error) => {
      console.log(error);
      var msg =
        "There was an error connecting to the session. Code: " +
        error.code +
        ". Message: " +
        error.message;
      console.error(msg);
      alert(msg);
    });
  };

  const autoplayMutedVideoIfBlocked = (video) => {
    video.controls = true;
    var promise = video.play();
    if (promise !== undefined) {
      promise
        .then(() => {})
        .catch((error) => {
          video.muted = true;
          video.play();
        });
    }
  };

  return (
    <div>
      {loading && <Loader loaded={!loading} color='grey'/>}
      {!sessionId && <h1 className={styles.noCamerasTitle} >Нет настроенных видеокамер</h1>}
      <div id="cameras" className={styles.cameras}/>
    </div>
  );

  // return (
  //   <div>
  //     <h1 className={styles.noCamerasTitle} >Нет настроенных видеокамер</h1>
  //     <div id="cameras" className={styles.cameras}/>
  //   </div>
  // );
}
